let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lh6yL")).then(() => parcelRequire('jz6bj'));